import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { NzMessageService } from 'ng-zorro-antd/message';
import { interval, Subscription } from 'rxjs';
import { Activity, Lot, Project } from '../../../core/models';
import { ActivityService, DeclarationInteractionService } from '../../../core/services';
import { HttpRequestService } from '../../../core/services/http/http-request.service';
import { NotificationInteractionService } from '../../../core/services/interaction-service/notification-interaction.service';
import { ActivityDeclarationMultiForm } from '../../forms';

@UntilDestroy()
@Component({
    selector: 'activity-declaration-multi',
    templateUrl: './activity-declaration-multi.component.html',
    styleUrls: ['./activity-declaration-multi.component.scss']
})
export class ActivityDeclarationMultiComponent implements OnInit {

    @Output() public closeEvent: EventEmitter<any> = new EventEmitter();
    public form: ActivityDeclarationMultiForm = new ActivityDeclarationMultiForm();
    public projects: Project[] = [];
    public lots: Lot[] = [];
    public isConfirmLoading = false;
    private projectSubscription: Subscription = null;
    private createSubscription: Subscription = null;

    constructor(private activityService: ActivityService,
                private nzMessageService: NzMessageService,
                private notificationInteractionService: NotificationInteractionService,
                private declarationInteractionService: DeclarationInteractionService,
                private httpRequestService: HttpRequestService) {
        this.projectSubscription = this.activityService.getProjectsForDeclarations().subscribe(projects => {
            this.projects = projects;
        });
    }

    ngOnInit() {
        interval(1000).pipe(untilDestroyed(this)).subscribe();
    }

    public closeModelHandler() {
        this.closeEvent.emit();
    }

    public sendDeclaration() {
        this.form.validate();
        if (this.form.validationForm.invalid) {
            this.nzMessageService.error('Veuillez remplir tous les champs obligatoires.');
            return;
        }

        this.createDeclarationMulti();
    }

    public projectChangedHandler(projectId: number) {
        this.form.validationForm.get('lotId').setValue(null);
        this.getLotsOfProject();
    }

    private createDeclarationMulti() {
        this.isConfirmLoading = true;
        this.createSubscription = this.activityService.createMultiActivity(this.form).subscribe((activities: Activity[]) => {
            activities.forEach((item: Activity) => {
                this.declarationInteractionService.createActivity(item);
            });
            this.closeModelHandler();
            this.nzMessageService.success('Création réussie !');
            this.form = new ActivityDeclarationMultiForm();
        }, err => {
            if (err && err.messages) {
                this.nzMessageService.error(err.messages.join('\n'));
            }
        }, () => {
            this.isConfirmLoading = false;
        });
    }

    private getLotsOfProject() {
        const projectId = this.form.validationForm.get('projectId').value;
        if (projectId) {
            this.projects.forEach((project: Project) => {
                if (project.id === projectId) {
                    this.lots = this.httpRequestService.mapToModel(Lot, project.lots) as Lot[];
                }
            });
        }
    }
}
